import React from 'react'

import {
  AcademicCapIcon,
  BriefcaseIcon,
  OfficeBuildingIcon,
  PresentationChartBarIcon
} from '@heroicons/react/outline'

const timelineSteps = [
  {
    icon: <AcademicCapIcon className="w-5 h-5 text-white" />,
    title: 'Foundation',
    duration: '12 months',
    description:
      'Learn Frontend, Backend and Data structures and build 5+ projects'
  },
  {
    icon: <PresentationChartBarIcon className="w-5 h-5 text-white" />,
    title: 'Major Project',
    duration: '3 Months',
    description: 'Work on your Major Capstone Project'
  },
  {
    icon: <BriefcaseIcon className="w-5 h-5 text-white" />,
    title: 'Experience',
    duration: '12 Months',
    description:
      'Intern at a top tech company or startup and gain real-world experience'
  },
  {
    icon: <OfficeBuildingIcon className="w-5 h-5 text-white" />,
    title: 'Specialisation',
    duration: '9 Months',
    description:
      'Choose your own Specialisation like AI or build your own startup'
  }
]

const Duration = () => {
  return (
    <section className="max-w-4xl mx-auto px-2 py-12 sm:px-4 lg:max-w-screen-2xl lg:px-6 space-y-10 w-full">
      <h3
        className="text-left text-3xl md:text-4xl font-semibold tracking-tight"
        style={{
          textDecoration: 'underline',
          textDecorationColor: '#FDBA74',
          textDecorationThickness: '10px',
          textDecorationSkipInk: 'none',
          textUnderlineOffset: '-40%',
          textUnderlinePosition: 'under'
        }}>
        Timeline
      </h3>

      <ol className="sm:flex">
        {timelineSteps.map((step, idx) => (
          <li
            className="relative mb-6 sm:mb-0 xl:min-w-[350px] min-w-none"
            key={idx}>
            <div className="flex items-center">
              <div className="z-10 flex items-center justify-center w-14 h-14 bg-orange-500 rounded-full border-8 border-orange-200 shrink-0">
                {step.icon}
              </div>
              <div className="hidden sm:flex w-full bg-orange-200 h-2"></div>
            </div>
            <div className="mt-4 pl-1 space-y-3">
              <h3 className="inline-flex text-base md:text-lg lg:text-xl font-medium text-gray-700 tracking-wide">
                {step.title}
              </h3>
              <span className="ml-1 text-orange-500 font-medium">
                ({step.duration})
              </span>
              <p className="text-base md:text-lg font-normal text-zinc-700 max-w-[350px]">
                {step.description}
              </p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  )
}

export default Duration
